import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const BookPen: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_33540)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.2111 2.38826L21.1315 1.75371L14.793 12.9288L14.6954 14.3692L15.8716 13.5634L22.2111 2.38826ZM18.8371 9.69269V21.7309C18.8371 22.0281 18.5991 22.2703 18.3071 22.2703H4.78538C4.49338 22.2703 4.25544 22.0291 4.25544 21.7309V18.556H4.80097C5.3652 18.556 5.82552 18.0886 5.82552 17.5143V16.5773C5.82552 16.0031 5.36623 15.5356 4.80097 15.5356H4.25544V13.5791H4.80097C5.3652 13.5791 5.82552 13.1117 5.82552 12.5364V11.5994C5.82552 11.0251 5.36623 10.5566 4.80097 10.5566H4.25544V8.60011H4.80097C5.3652 8.60011 5.82552 8.13266 5.82552 7.55841V6.62142C5.82552 6.04716 5.36623 5.57971 4.80097 5.57971H4.25544V2.4048C4.25544 2.10762 4.49339 1.8665 4.78538 1.8665H18.3071C18.5991 1.8665 18.8371 2.10763 18.8371 2.4048V4.44165L14.1766 12.6568C14.1506 12.7012 14.1361 12.752 14.1329 12.8028L13.9833 15.0131C13.975 15.1421 14.0394 15.2658 14.1485 15.3304C14.2005 15.361 14.2576 15.3758 14.3158 15.3758C14.3803 15.3758 14.4457 15.3568 14.5018 15.3177L16.3078 14.0803C16.3494 14.0518 16.3847 14.0126 16.4096 13.9682L18.8371 9.69269ZM2.02347 17.877H4.80086C4.99725 17.877 5.15832 17.7141 5.15832 17.5143V16.5773C5.15832 16.3774 4.9983 16.2146 4.80086 16.2146H2.02347C1.82604 16.2146 1.66601 16.3774 1.66601 16.5773V17.5143C1.66704 17.7152 1.82603 17.877 2.02347 17.877ZM2.02347 12.9001H4.80086C4.99725 12.9001 5.15832 12.7372 5.15832 12.5363V11.5993C5.15832 11.3994 4.9983 11.2355 4.80086 11.2355H2.02347C1.82604 11.2355 1.66601 11.3983 1.66601 11.5993V12.5363C1.66704 12.7372 1.82603 12.9001 2.02347 12.9001ZM2.02347 7.92208H4.80086C4.99725 7.92208 5.15832 7.75922 5.15832 7.55827V6.62128C5.15832 6.42141 4.9983 6.25855 4.80086 6.25855H2.02347C1.82604 6.25855 1.66601 6.42142 1.66601 6.62128V7.55827C1.66704 7.75921 1.82603 7.92208 2.02347 7.92208ZM22.9551 2.43348L19.5042 8.5177V21.7309C19.5042 22.4025 18.968 22.9492 18.3072 22.9492L4.78543 22.9482C4.1256 22.9482 3.58943 22.4025 3.58943 21.7299V18.556H2.02456C1.45929 18.556 1 18.0886 1 17.5143V16.5773C1 16.0031 1.45929 15.5356 2.02456 15.5356H3.58943V13.5791H2.02456C1.45929 13.5791 1 13.1117 1 12.5364V11.5994C1 11.0251 1.45929 10.5566 2.02456 10.5566H3.58943V8.60014H2.02456C1.45929 8.60014 1 8.13269 1 7.55843V6.62144C1 6.04719 1.45929 5.57974 2.02456 5.57974H3.58943V2.40483C3.58943 1.73222 4.1256 1.18652 4.78543 1.18652H18.3072C18.967 1.18652 19.5042 1.73222 19.5042 2.40483V3.26569L20.722 1.1199C20.7667 1.04269 20.8394 0.985587 20.9246 0.960205C21.0098 0.936939 21.1003 0.951745 21.1782 0.994047L22.8345 1.96807C22.9925 2.06325 23.0476 2.2706 22.9551 2.43348ZM15.1765 16.7063H7.95067C7.76675 16.7063 7.61712 16.8586 7.61712 17.0458C7.61712 17.233 7.76675 17.3853 7.95067 17.3853H15.1765C15.3604 17.3853 15.5101 17.233 15.5101 17.0458C15.509 16.8586 15.3604 16.7063 15.1765 16.7063ZM7.95067 12.4073H12.7918C12.9757 12.4073 13.1253 12.2551 13.1253 12.0679C13.1253 11.8796 12.9757 11.7284 12.7918 11.7284H7.95067C7.76675 11.7284 7.61712 11.8807 7.61712 12.0679C7.61712 12.2561 7.76675 12.4073 7.95067 12.4073ZM7.61712 7.08984C7.61712 6.90266 7.76675 6.75037 7.95067 6.75037H15.1765C15.3604 6.75037 15.5101 6.90266 15.5101 7.08984C15.5101 7.27703 15.3604 7.42932 15.1765 7.42932H7.95067C7.76675 7.42932 7.61712 7.27703 7.61712 7.08984Z'
          fill='url(#paint0_linear_12280_33540)'
          stroke='url(#paint1_linear_12280_33540)'
          strokeWidth='0.8'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_33540'
          x1='5.55569'
          y1='2.44937'
          x2='15.5813'
          y2='22.5434'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_33540'
          x1='5.55569'
          y1='2.44937'
          x2='15.5813'
          y2='22.5434'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_33540'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BookPen;
